import { hbs } from 'ember-cli-htmlbars';
export default hbs("<tbody ...attributes>\n\n  {{yield (component \'ui/table/row\')}}\n\n</tbody>")